import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, provideAppInitializer, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { InyovaConfigModule, InyovaSharedModule } from '@inyova/inyova-shared';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader, TranslateHttpLoader } from '@ngx-translate/http-loader';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { RootEffects } from './app.effects';
import * as fromRoot from './app.reducers';

import { HomePageModule } from '@home/home.module';
import { PublicModule } from '@public/public.module';
import { DeviceService } from '@shared/services/device.service';
import { HttpRequestInterceptor } from '@shared/services/http.interceptor';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { Languages } from './app.constants';
import { environment } from '../environments/environment';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    EffectsModule.forRoot([RootEffects]),
    IonicModule.forRoot(),
    IonicStorageModule.forRoot(),
    HomePageModule,
    PublicModule,
    ReactiveFormsModule,
    InyovaSharedModule,
    InyovaConfigModule.forRoot({ url: environment.apiUrl, urlV3: environment.apiUrlV3, urlV4: environment.apiUrlV4 }),
    TranslateModule.forRoot({
      fallbackLang: Languages.DE_CH,
      loader: {
        provide: TranslateLoader,
        useClass: TranslateHttpLoader
      }
    }),
    StoreModule.forRoot(
      { root: fromRoot.reducer },
      {
        // See: https://ngrx.io/guide/store/configuration/runtime-checks
        runtimeChecks: {
          strictActionImmutability: false,
          strictActionSerializability: false,
          strictStateImmutability: !environment.production,
          strictStateSerializability: false
        }
      }
    ),
    !environment.production ? StoreDevtoolsModule.instrument() : []
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideAppInitializer(() => inject(DeviceService).init()),
    provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' })
  ]
})
export class AppModule {}
